
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.35276',
  depVersions: {
  "documents-public-ui": "static-1.35276",
  "atom": "static-1.5420",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2820",
  "client-types": "static-1.501",
  "cssUtils": "static-1.960",
  "customer-data-filters-ui": "static-1.41022",
  "customer-data-objects": "static-1.8035",
  "customer-data-property-utils": "static-1.8436",
  "documents-lib": "static-1.35281",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.373",
  "FormsCommonComponents": "static-1.86643",
  "FormUrlGenerator": "static-2.5064",
  "foundations-theming-specialty": "static-1.2530",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.111",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5928",
  "hs-test-utils": "static-1.8371",
  "hub-http": "static-1.6550",
  "hubspot-dlb": "static-2.1905",
  "HubStyle": "static-2.12136",
  "HubStyleTokens": "static-2.11829",
  "I18n": "static-7.1679",
  "icons": "static-2.693",
  "jasmine-immutable": "static-1.3358",
  "jasmine-runner": "static-1.6788",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7491",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.3230",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5732",
  "quartz": "static-1.7505",
  "react": "static-7.196",
  "react-dlb": "static-1.89",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.79",
  "react-rhumb": "static-1-fkhalid-rhumb-remove-redundant-softnav.2",
  "react-select-plus": "static-1.113",
  "react-utils": "static-2.5580",
  "react-virtualized": "static-2.107",
  "reference-resolvers": "static-1.8519",
  "reference-resolvers-lite": "static-1.8442",
  "reporting-data": "static-1.68921",
  "reporting-reports": "static-1.68597",
  "reporting-snowflake": "static-1.57537",
  "reporting-testing-lib": "static-1.10854",
  "reporting-visualizations": "static-1.60995",
  "reselect": "static-3.12",
  "sales-content-partitioning": "static-1.9290",
  "sanitize": "static-1.4810",
  "sanitize-text": "static-1.8495",
  "SharedI18nStrings": "static-1.183",
  "SharedLegalStrings": "static-1.2080",
  "signup-constants": "static-1.19684",
  "signup-ui-url-generator": "static-2.8398",
  "StyleGuideUI": "static-3.507",
  "superstore": "static-1.5097",
  "tinymce": "static-6.5",
  "transmute": "static-2.97",
  "ui-addon-draggable": "static-3.5094",
  "ui-addon-form-validation": "static-1.11322",
  "ui-asset-management-lib": "static-1.11438",
  "ui-images": "static-2.1262",
  "UIComponents": "static-3.8775",
  "usage-tracker": "static-1.7651",
  "usage-tracker-container": "static-1.7641",
  "usage-tracker-core": "static-1.7501",
  "viral-links-lib": "static-1.7414",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9991",
  "foundations-components": "static-1.8544",
  "immutable": "static-2.87",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1283",
  "quartz-core": "static-1.6724",
  "quick-fetch": "static-1.4152",
  "raven": "static-3.5925",
  "redux": "static-4.80",
  "redux-thunk": "static-2.80",
  "rpc-client-utils": "static-1.5004",
  "ui-addon-i18n": "static-1.11484",
  "ui-addon-upgrades": "static-9.18428",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4366",
  "metrics-js": "static-1.9963",
  "styled-components": "static-2.99",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3782",
  "quartz-webpack": "static-1.3729",
  "foundations-assets": "static-1.5225",
  "foundations-theming": "static-1.4814",
  "hub-http-janus": "static-1.887",
  "hub-http-shared-msw-handlers": "static-1.10677",
  "hubspotter-http": "static-1.4888",
  "sassPrefix": "static-1.227",
  "conversations-skeleton-state": "static-1.7585",
  "crm-message-bus": "static-1.43839",
  "customer-data-filters-ui-msw-helpers": "static-1.23457",
  "customer-data-objects-ui-components": "static-1.13369",
  "customer-data-reference-ui-components": "static-1.13517",
  "customer-data-ui-utilities": "static-1.10169",
  "events-data-lib": "static-1.587",
  "framework-builder-read-service-client": "static-1.4246",
  "hs-resources": "static-1.531",
  "immer": "static-1.101",
  "inbound-db-meta-service-client": "static-1.3718",
  "inbound-db-properties-service-client": "static-1.4072",
  "multi-account-reference-resolvers": "static-1.1346",
  "onboarding-scopes": "static-1.6791",
  "onboarding-tours": "static-1.17182",
  "pulse": "static-1.968",
  "reporting-datasets-permissions-lib": "static-1.14529",
  "stylex": "static-1.41",
  "trellis-assets": "static-1.2734",
  "trellis-components": "static-1.2753",
  "trellis-theming": "static-1.1311",
  "ui-addon-teams": "static-1.21949",
  "quartz-auth": "static-1.1180",
  "ui-business-units-lib": "static-1.9429",
  "usage-tracker-session-replay": "static-1.5337",
  "ai-components-ui-library": "static-1.9792",
  "ContentUtils": "static-1.69198",
  "customer-data-properties": "static-1.52691",
  "forms-ai-lib": "static-1.4807",
  "forms-utils-lib": "static-1.13138",
  "foundations-components-test-utils": "static-1.6027",
  "react-dnd-compat": "static-1.4954",
  "react-tinymce": "static-1.56044",
  "tinymce-config": "static-2.55170",
  "ui-gdpr-components": "static-1.10634",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3799",
  "HeadJS": "static-2.803",
  "framer-motion": "static-1.79",
  "hs-test-utils-bend-plugin": "static-1.3482",
  "msw": "static-1.39",
  "testing-library": "static-1.158",
  "hs-locale-management": "static-1.319",
  "ui-fonts": "static-1.1091",
  "i18n-data": "static-1.230",
  "moment-timezone": "static-5.91",
  "jasmine": "static-4.4650",
  "csstype": "static-1.50",
  "quartz-head": "static-1.1170",
  "web-vitals": "static-1.15",
  "batch-promise": "static-1.1883",
  "external-options-client-types": "static-1.4365",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7231",
  "quartz-i18n": "static-1.1180",
  "frontend-preferences-client": "static-1.8257",
  "graphql": "static-1.89",
  "persist-promise": "static-1.4040",
  "reporting-client-types": "static-1.2716",
  "apollo-stack-hubspot": "static-3.94",
  "growth-payments-core": "static-1.26254",
  "hubspot-apollo-client": "static-1.5215",
  "foundations-components-legacy": "static-1.1569",
  "quartz-routing": "static-1.935",
  "hs-story-utils": "static-1.9763",
  "react-flip-move": "static-1.78",
  "nested-table": "static-1.573",
  "seat-types-lib": "static-1.799",
  "timezone-utils": "static-2.5581",
  "react-create-root-preference": "static-1.78",
  "bend-plugin-foundations-components": "static-1.4813",
  "floating-ui": "static-1.63",
  "react-aria": "static-1.72",
  "tanstack-table": "static-1.61",
  "opentelemetry-fe-types": "static-1.114",
  "dispatcher": "static-1.143",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.583",
  "module-federation": "static-1.33",
  "opentelemetry-fe": "static-1.489",
  "quartz-test": "static-1.1180",
  "quartz-tracking": "static-1.884",
  "bend-plugin-chirp-manifest": "static-1.414",
  "chirp-fetch": "static-1.2234",
  "merchandise-lib": "static-1.279",
  "purchase-motions-components": "static-1.6423",
  "ts-schema": "static-1.4318",
  "bender-build-tools": "static-1.3452",
  "bend-plugin-foundations-theming": "static-1.3297",
  "restore-request-side-panel-lib": "static-1.1740",
  "react-immutable-render-mixin": "static-1.9",
  "apollo-link-hub-http": "static-2.4995",
  "conditional-properties-service-client": "static-1.4041",
  "crm-pipelines-api-client-types": "static-1.4372",
  "event-emitter": "static-1.1293",
  "fdsr-migration-layer": "static-1.350",
  "multi-currency-client-types": "static-1.3932",
  "getting-started-shared-tasks": "static-1.19312",
  "growth-data-modal": "static-1.5941",
  "growth-onboarding-confetti": "static-1.3403",
  "growth-onboarding-next-action-utils": "static-1.2754",
  "navigation-components": "static-1.18901",
  "onboarding-tours-client": "static-1.5397",
  "onboarding-tours-utils": "static-1.1249",
  "ui-shepherd-react": "static-3.10608",
  "ui-shepherd-tracker": "static-1.7989",
  "ui-universal-auth": "static-1.9467",
  "user-context": "static-1.5459",
  "bend-plugin-pulse": "static-1.471",
  "fast-json-patch": "static-1.70",
  "stylex-utils": "static-1.147",
  "base-ui": "static-1.22",
  "react-day-picker": "static-1.10",
  "tanstack-virtual": "static-1.38",
  "hubspotter-http-shared-msw-handlers": "static-1.10675",
  "magpie-lib": "static-1.5783",
  "navigation-messaging": "static-1.8228",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.23183",
  "copilot-toolkit": "static-1.11907",
  "cms-field-types": "static-1.5150",
  "content-icons-ui": "static-1.2401",
  "integrations-lib": "static-1.17139",
  "calling-global-api": "static-1.65737",
  "calling-internal-common": "static-1.31660",
  "calling-lifecycle-internal": "static-1.67119",
  "calling-lifecycle-messages": "static-1.59413",
  "commerce-products-lib": "static-1.10614",
  "crm-index-visualization-core": "static-1.4586",
  "crm-links": "static-1.6658",
  "customer-data-properties-shared-msw-handlers": "static-1.10004",
  "file-manager-components": "static-1.24584",
  "formula-editor": "static-1.14817",
  "google-libphonenumber": "static-1.45",
  "inbounddb-objects-service-types": "static-1.4453",
  "meetings-icalendar-utils-lib": "static-1.973",
  "object-builder-ui-client": "static-1.49759",
  "pipeline-validation-client-types": "static-1.4207",
  "property-value-citations": "static-1.3306",
  "smart-data-capture-core": "static-1.200",
  "smart-property-lib": "static-1.8371",
  "tiered-pricing": "static-1.2013",
  "topics-actions-lib": "static-1.508",
  "trial-components-library": "static-1.14166",
  "ui-addon-iframeable": "static-1.9415",
  "zustand": "static-1.85",
  "final-form": "static-1.78",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.78",
  "rich-text-lib": "static-1.20353",
  "tinymce-themes": "static-1.57140",
  "data-token-picker": "static-1.16933",
  "hub-http-contrib": "static-1.3378",
  "interframe": "static-3.5093",
  "tinymce-data": "static-1.41255",
  "tinymce-plugins": "static-1.58284",
  "ui-addon-sales-email": "static-1.5552",
  "framework-data-schema-quick-fetch": "static-1.7136",
  "ui-addon-opt": "static-4.8704",
  "hubspot-apollo-cache": "static-1.674",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.486",
  "opentelemetry-web": "static-1.15",
  "beacon-keepalive-queue": "static-1.42",
  "purchase-motions-api": "static-1.6426",
  "onboarding-data-sync-lib": "static-1.2563",
  "growth-onboarding-next-action-components": "static-1.2782",
  "user-context-client": "static-1.4846",
  "idb-keyval": "static-1.51",
  "magpie-types": "static-1.5243",
  "nest": "static-1.575",
  "reactive-lib": "static-1.1057",
  "simple-logging-lib": "static-1.3389",
  "unified-auth-core-lib": "static-1.1263",
  "getting-started-shared-tasks-store": "static-1.18430",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1829",
  "integrations-error-boundary-lib": "static-1.14554",
  "integrations-tracking-lib": "static-1.5946",
  "native-integrations-shared-strings": "static-1.8115",
  "redux-observable": "static-1.75",
  "ReduxMessenger": "static-2.10708",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.981",
  "calling-error-reporting": "static-1.31667",
  "shared-worker-versioning": "static-1.11379",
  "calling-usage-tracker": "static-1.6874",
  "voice-sms-access-library": "static-1.2133",
  "customer-data-tracking": "static-1.7220",
  "commerce-permissions": "static-1.1115",
  "products-iframe-lib": "static-1.8647",
  "products-ui-components-shared-msw-handlers": "static-1.11059",
  "crm-index-associations-lib": "static-1.6782",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10760",
  "sales-views-client-types": "static-1.4594",
  "location-customization-utils-lib": "static-1.10168",
  "apollo-dlb": "static-3.98",
  "immerable": "static-1.4484",
  "video-components-external": "static-1.12211",
  "video-data-lib": "static-1.35869",
  "bark-lib": "static-1.16853",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.102",
  "crm-properties-common-lib": "static-1.6228",
  "react-codemirror": "static-1.10981",
  "data-agent-kit": "static-1.699",
  "feedback-loader": "static-1.29857",
  "fsm": "static-1.4091",
  "policy-lib": "static-1.7143",
  "react-colorpicker": "static-2.10551",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10823",
  "embedded-academy-lib": "static-1.15632",
  "hubs-service-types": "static-1.1598",
  "salesImages": "static-1.598",
  "FileManagerLib": "static-1.40224",
  "NamespacedHubStyle": "static-2.9290",
  "FileManagerCore": "static-1.40083",
  "content-assistance-lib": "static-1.8244",
  "layout-dnd-components": "static-1.13019",
  "layout-dnd-utils": "static-1.11994",
  "ui-addon-emoji-picker": "static-1.10222",
  "ui-brand-identity-lib": "static-1.16621",
  "InboxConnectUtils": "static-4.15620",
  "meetings-connect-utils-lib": "static-1.7949",
  "breeze-engine-chat-components": "static-1.807",
  "breeze-engine-core": "static-1.1107",
  "ably": "static-2.2",
  "highlight.js": "static-1.86",
  "universal-page-editor-lib": "static-1.3346",
  "adobe-sign-auth-lib": "static-1.532",
  "ads-unified-auth-lib": "static-1.1503",
  "custom-vendor-connection-lib": "static-1.31",
  "google-sheets-integration-lib": "static-1.1095",
  "microsoft-drive-auth-lib": "static-1.211",
  "surveymonkey-integration-lib": "static-1.550",
  "slack-ui-library": "static-1.10737",
  "calling-orchestration-schema": "static-1.36910",
  "crm-record-cards-service-types": "static-1.3796",
  "content-media-composition-data-lib": "static-1.13321",
  "content-media-compositions": "static-2.17328",
  "media-bridge-lib": "static-1.19451",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16428",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4845",
  "storybook-react": "static-1.40",
  "academy-common-lib": "static-1.15092",
  "audio-components": "static-1.6391",
  "FileManagerImages": "static-1.37735",
  "video-components": "static-1.14213",
  "breeze-artifacts-sdk": "static-1.455",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.61",
  "urlinator": "static-1.4868",
  "video-embed": "static-1.36703",
  "ui-addon-video-player": "static-1.9040",
  "ui-coaching-tips": "static-1.29373",
  "ContentData": "static-1.69273",
  "layout-data-lib": "static-1.10319",
  "academy-service-client": "static-1.4030",
  "croppie": "static-2.10",
  "SafeStorage": "static-1.4744",
  "trellis-ecosystem": "static-1.7672",
  "ui-addon-react-router-dom": "static-1.9870",
  "wootric-nps": "static-1.7225",
  "social-insights-client-types": "static-1.22706",
  "outpost": "static-1.4491",
  "growth-onboarding-feedback-components": "static-1.6923",
  "advanced-menus-core": "static-1.15624",
  "advanced-menus-lib": "static-1.12495",
  "ExportDialog": "static-6.10716",
  "ui-memberships-settings-lib": "static-1.34907",
  "marketplace-ui-apps-core": "static-1.19334",
  "marketplace-ui-common": "static-1.20802",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15623",
  "simple-menus-lib": "static-1.17140",
  "settings-ui-lib": "static-1.12862",
  "developer-experience-shared-components": "static-1.10876",
  "immutable-less": "static-1.4989",
  "marketplace-ui-client-types": "static-1.18209",
  "ui-addon-integrations-directory-panel": "static-2.8365",
  "ui-extensibility-client-types": "static-1.4255",
  "ai-settings-ui-library": "static-1.8389",
  "nav-meta": "static-1.30538",
  "ui-product-approvals-common": "static-1.1170",
  "apps-service-types": "static-1.4067",
  "oauth-service-types": "static-1.4571",
  "simple-data-table": "static-1.3579"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.35276",
  "atom": "/atom/static-1.5420",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2820",
  "client-types": "/client-types/static-1.501",
  "cssUtils": "/cssUtils/static-1.960",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41022",
  "customer-data-objects": "/customer-data-objects/static-1.8035",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8436",
  "documents-lib": "/documents-lib/static-1.35281",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.373",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86643",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5064",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2530",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.111",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5928",
  "hs-test-utils": "/hs-test-utils/static-1.8371",
  "hub-http": "/hub-http/static-1.6550",
  "hubspot-dlb": "/hubspot-dlb/static-2.1905",
  "HubStyle": "/HubStyle/static-2.12136",
  "HubStyleTokens": "/HubStyleTokens/static-2.11829",
  "I18n": "/I18n/static-7.1679",
  "icons": "/icons/static-2.693",
  "jasmine-immutable": "/jasmine-immutable/static-1.3358",
  "jasmine-runner": "/jasmine-runner/static-1.6788",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7491",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.3230",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5732",
  "quartz": "/quartz/static-1.7505",
  "react": "/react/static-7.196",
  "react-dlb": "/react-dlb/static-1.89",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.79",
  "react-rhumb": "/react-rhumb/static-1-fkhalid-rhumb-remove-redundant-softnav.2",
  "react-select-plus": "/react-select-plus/static-1.113",
  "react-utils": "/react-utils/static-2.5580",
  "react-virtualized": "/react-virtualized/static-2.107",
  "reference-resolvers": "/reference-resolvers/static-1.8519",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8442",
  "reporting-data": "/reporting-data/static-1.68921",
  "reporting-reports": "/reporting-reports/static-1.68597",
  "reporting-snowflake": "/reporting-snowflake/static-1.57537",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10854",
  "reporting-visualizations": "/reporting-visualizations/static-1.60995",
  "reselect": "/reselect/static-3.12",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9290",
  "sanitize": "/sanitize/static-1.4810",
  "sanitize-text": "/sanitize-text/static-1.8495",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.183",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2080",
  "signup-constants": "/signup-constants/static-1.19684",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8398",
  "StyleGuideUI": "/StyleGuideUI/static-3.507",
  "superstore": "/superstore/static-1.5097",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.97",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5094",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11322",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11438",
  "ui-images": "/ui-images/static-2.1262",
  "UIComponents": "/UIComponents/static-3.8775",
  "usage-tracker": "/usage-tracker/static-1.7651",
  "usage-tracker-container": "/usage-tracker-container/static-1.7641",
  "usage-tracker-core": "/usage-tracker-core/static-1.7501",
  "viral-links-lib": "/viral-links-lib/static-1.7414",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9991",
  "foundations-components": "/foundations-components/static-1.8544",
  "immutable": "/immutable/static-2.87",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1283",
  "quartz-core": "/quartz-core/static-1.6724",
  "quick-fetch": "/quick-fetch/static-1.4152",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.80",
  "redux-thunk": "/redux-thunk/static-2.80",
  "rpc-client-utils": "/rpc-client-utils/static-1.5004",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11484",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18428",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4366",
  "metrics-js": "/metrics-js/static-1.9963",
  "styled-components": "/styled-components/static-2.99",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3782",
  "quartz-webpack": "/quartz-webpack/static-1.3729",
  "foundations-assets": "/foundations-assets/static-1.5225",
  "foundations-theming": "/foundations-theming/static-1.4814",
  "hub-http-janus": "/hub-http-janus/static-1.887",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10677",
  "hubspotter-http": "/hubspotter-http/static-1.4888",
  "sassPrefix": "/sassPrefix/static-1.227",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7585",
  "crm-message-bus": "/crm-message-bus/static-1.43839",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23457",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13369",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13517",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10169",
  "events-data-lib": "/events-data-lib/static-1.587",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4246",
  "hs-resources": "/hs-resources/static-1.531",
  "immer": "/immer/static-1.101",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4072",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1346",
  "onboarding-scopes": "/onboarding-scopes/static-1.6791",
  "onboarding-tours": "/onboarding-tours/static-1.17182",
  "pulse": "/pulse/static-1.968",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14529",
  "stylex": "/stylex/static-1.41",
  "trellis-assets": "/trellis-assets/static-1.2734",
  "trellis-components": "/trellis-components/static-1.2753",
  "trellis-theming": "/trellis-theming/static-1.1311",
  "ui-addon-teams": "/ui-addon-teams/static-1.21949",
  "quartz-auth": "/quartz-auth/static-1.1180",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9429",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5337",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9792",
  "ContentUtils": "/ContentUtils/static-1.69198",
  "customer-data-properties": "/customer-data-properties/static-1.52691",
  "forms-ai-lib": "/forms-ai-lib/static-1.4807",
  "forms-utils-lib": "/forms-utils-lib/static-1.13138",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6027",
  "react-dnd-compat": "/react-dnd-compat/static-1.4954",
  "react-tinymce": "/react-tinymce/static-1.56044",
  "tinymce-config": "/tinymce-config/static-2.55170",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10634",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3799",
  "HeadJS": "/HeadJS/static-2.803",
  "framer-motion": "/framer-motion/static-1.79",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3482",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.158",
  "hs-locale-management": "/hs-locale-management/static-1.319",
  "ui-fonts": "/ui-fonts/static-1.1091",
  "i18n-data": "/i18n-data/static-1.230",
  "moment-timezone": "/moment-timezone/static-5.91",
  "jasmine": "/jasmine/static-4.4650",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.1170",
  "web-vitals": "/web-vitals/static-1.15",
  "batch-promise": "/batch-promise/static-1.1883",
  "external-options-client-types": "/external-options-client-types/static-1.4365",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7231",
  "quartz-i18n": "/quartz-i18n/static-1.1180",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8257",
  "graphql": "/graphql/static-1.89",
  "persist-promise": "/persist-promise/static-1.4040",
  "reporting-client-types": "/reporting-client-types/static-1.2716",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "growth-payments-core": "/growth-payments-core/static-1.26254",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5215",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1569",
  "quartz-routing": "/quartz-routing/static-1.935",
  "hs-story-utils": "/hs-story-utils/static-1.9763",
  "react-flip-move": "/react-flip-move/static-1.78",
  "nested-table": "/nested-table/static-1.573",
  "seat-types-lib": "/seat-types-lib/static-1.799",
  "timezone-utils": "/timezone-utils/static-2.5581",
  "react-create-root-preference": "/react-create-root-preference/static-1.78",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4813",
  "floating-ui": "/floating-ui/static-1.63",
  "react-aria": "/react-aria/static-1.72",
  "tanstack-table": "/tanstack-table/static-1.61",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.114",
  "dispatcher": "/dispatcher/static-1.143",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.583",
  "module-federation": "/module-federation/static-1.33",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.489",
  "quartz-test": "/quartz-test/static-1.1180",
  "quartz-tracking": "/quartz-tracking/static-1.884",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.414",
  "chirp-fetch": "/chirp-fetch/static-1.2234",
  "merchandise-lib": "/merchandise-lib/static-1.279",
  "purchase-motions-components": "/purchase-motions-components/static-1.6423",
  "ts-schema": "/ts-schema/static-1.4318",
  "bender-build-tools": "/bender-build-tools/static-1.3452",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3297",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1740",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4995",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4041",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4372",
  "event-emitter": "/event-emitter/static-1.1293",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.350",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3932",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19312",
  "growth-data-modal": "/growth-data-modal/static-1.5941",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3403",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2754",
  "navigation-components": "/navigation-components/static-1.18901",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5397",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1249",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10608",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7989",
  "ui-universal-auth": "/ui-universal-auth/static-1.9467",
  "user-context": "/user-context/static-1.5459",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.471",
  "fast-json-patch": "/fast-json-patch/static-1.70",
  "stylex-utils": "/stylex-utils/static-1.147",
  "base-ui": "/base-ui/static-1.22",
  "react-day-picker": "/react-day-picker/static-1.10",
  "tanstack-virtual": "/tanstack-virtual/static-1.38",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10675",
  "magpie-lib": "/magpie-lib/static-1.5783",
  "navigation-messaging": "/navigation-messaging/static-1.8228",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.23183",
  "copilot-toolkit": "/copilot-toolkit/static-1.11907",
  "cms-field-types": "/cms-field-types/static-1.5150",
  "content-icons-ui": "/content-icons-ui/static-1.2401",
  "integrations-lib": "/integrations-lib/static-1.17139",
  "calling-global-api": "/calling-global-api/static-1.65737",
  "calling-internal-common": "/calling-internal-common/static-1.31660",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67119",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59413",
  "commerce-products-lib": "/commerce-products-lib/static-1.10614",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4586",
  "crm-links": "/crm-links/static-1.6658",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10004",
  "file-manager-components": "/file-manager-components/static-1.24584",
  "formula-editor": "/formula-editor/static-1.14817",
  "google-libphonenumber": "/google-libphonenumber/static-1.45",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4453",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.973",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49759",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4207",
  "property-value-citations": "/property-value-citations/static-1.3306",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.200",
  "smart-property-lib": "/smart-property-lib/static-1.8371",
  "tiered-pricing": "/tiered-pricing/static-1.2013",
  "topics-actions-lib": "/topics-actions-lib/static-1.508",
  "trial-components-library": "/trial-components-library/static-1.14166",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9415",
  "zustand": "/zustand/static-1.85",
  "final-form": "/final-form/static-1.78",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.78",
  "rich-text-lib": "/rich-text-lib/static-1.20353",
  "tinymce-themes": "/tinymce-themes/static-1.57140",
  "data-token-picker": "/data-token-picker/static-1.16933",
  "hub-http-contrib": "/hub-http-contrib/static-1.3378",
  "interframe": "/interframe/static-3.5093",
  "tinymce-data": "/tinymce-data/static-1.41255",
  "tinymce-plugins": "/tinymce-plugins/static-1.58284",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5552",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7136",
  "ui-addon-opt": "/ui-addon-opt/static-4.8704",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.674",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.486",
  "opentelemetry-web": "/opentelemetry-web/static-1.15",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.42",
  "purchase-motions-api": "/purchase-motions-api/static-1.6426",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2563",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2782",
  "user-context-client": "/user-context-client/static-1.4846",
  "idb-keyval": "/idb-keyval/static-1.51",
  "magpie-types": "/magpie-types/static-1.5243",
  "nest": "/nest/static-1.575",
  "reactive-lib": "/reactive-lib/static-1.1057",
  "simple-logging-lib": "/simple-logging-lib/static-1.3389",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1263",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18430",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1829",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14554",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5946",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8115",
  "redux-observable": "/redux-observable/static-1.75",
  "ReduxMessenger": "/ReduxMessenger/static-2.10708",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.981",
  "calling-error-reporting": "/calling-error-reporting/static-1.31667",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11379",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6874",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2133",
  "customer-data-tracking": "/customer-data-tracking/static-1.7220",
  "commerce-permissions": "/commerce-permissions/static-1.1115",
  "products-iframe-lib": "/products-iframe-lib/static-1.8647",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11059",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6782",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10760",
  "sales-views-client-types": "/sales-views-client-types/static-1.4594",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10168",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "immerable": "/immerable/static-1.4484",
  "video-components-external": "/video-components-external/static-1.12211",
  "video-data-lib": "/video-data-lib/static-1.35869",
  "bark-lib": "/bark-lib/static-1.16853",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.102",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6228",
  "react-codemirror": "/react-codemirror/static-1.10981",
  "data-agent-kit": "/data-agent-kit/static-1.699",
  "feedback-loader": "/feedback-loader/static-1.29857",
  "fsm": "/fsm/static-1.4091",
  "policy-lib": "/policy-lib/static-1.7143",
  "react-colorpicker": "/react-colorpicker/static-2.10551",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10823",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15632",
  "hubs-service-types": "/hubs-service-types/static-1.1598",
  "salesImages": "/salesImages/static-1.598",
  "FileManagerLib": "/FileManagerLib/static-1.40224",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9290",
  "FileManagerCore": "/FileManagerCore/static-1.40083",
  "content-assistance-lib": "/content-assistance-lib/static-1.8244",
  "layout-dnd-components": "/layout-dnd-components/static-1.13019",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11994",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10222",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16621",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15620",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7949",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.807",
  "breeze-engine-core": "/breeze-engine-core/static-1.1107",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.86",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3346",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.532",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1503",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.31",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1095",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.211",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.550",
  "slack-ui-library": "/slack-ui-library/static-1.10737",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36910",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3796",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13321",
  "content-media-compositions": "/content-media-compositions/static-2.17328",
  "media-bridge-lib": "/media-bridge-lib/static-1.19451",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16428",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4845",
  "storybook-react": "/storybook-react/static-1.40",
  "academy-common-lib": "/academy-common-lib/static-1.15092",
  "audio-components": "/audio-components/static-1.6391",
  "FileManagerImages": "/FileManagerImages/static-1.37735",
  "video-components": "/video-components/static-1.14213",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.455",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.61",
  "urlinator": "/urlinator/static-1.4868",
  "video-embed": "/video-embed/static-1.36703",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9040",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29373",
  "ContentData": "/ContentData/static-1.69273",
  "layout-data-lib": "/layout-data-lib/static-1.10319",
  "academy-service-client": "/academy-service-client/static-1.4030",
  "croppie": "/croppie/static-2.10",
  "SafeStorage": "/SafeStorage/static-1.4744",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7672",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9870",
  "wootric-nps": "/wootric-nps/static-1.7225",
  "social-insights-client-types": "/social-insights-client-types/static-1.22706",
  "outpost": "/outpost/static-1.4491",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6923",
  "advanced-menus-core": "/advanced-menus-core/static-1.15624",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12495",
  "ExportDialog": "/ExportDialog/static-6.10716",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34907",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19334",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20802",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15623",
  "simple-menus-lib": "/simple-menus-lib/static-1.17140",
  "settings-ui-lib": "/settings-ui-lib/static-1.12862",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10876",
  "immutable-less": "/immutable-less/static-1.4989",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18209",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8365",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4255",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8389",
  "nav-meta": "/nav-meta/static-1.30538",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1170",
  "apps-service-types": "/apps-service-types/static-1.4067",
  "oauth-service-types": "/oauth-service-types/static-1.4571",
  "simple-data-table": "/simple-data-table/static-1.3579"
}
};
